import { render, staticRenderFns } from "./BeratungsauftragAktivitaetenListe.vue?vue&type=template&id=c56a0f02"
import script from "./BeratungsauftragAktivitaetenListe.vue?vue&type=script&lang=js"
export * from "./BeratungsauftragAktivitaetenListe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports